<template>
		<svg width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M0.295532 0.591064C0.159754 0.319508 0.357222 0 0.660831 0H7.24092C7.49716 0 7.73855 0.12024 7.89291 0.324767L10.6667 4L7.89291 7.67523C7.73855 7.87976 7.49716 8 7.24092 8H0.660831C0.357222 8 0.159754 7.68049 0.295532 7.40894L2 4L0.295532 0.591064Z" :fill="color"/>
		</svg>
</template>

<script>
export default {
	name: 'device-tag-icon',

	props: {
		color: {
			type: String,
			default: '#000000'
		}
	}
}
</script>

<style lang="scss" scoped>

</style>
